import script from "./ErrorMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorMsg.vue?vue&type=script&setup=true&lang=js"

import "./ErrorMsg.vue?vue&type=style&index=0&id=2128efef&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2128efef"]])

export default __exports__